import AzEnum from '@azinformatica/loki/src/filters/az-enum'

export default (situacao, Enum) => {
	if (situacao) {
		return AzEnum(situacao, Enum).text
	}
	return '--------'
}
